<app-workspace-overview></app-workspace-overview>

<mat-expansion-panel class="home-expansion-panel" [expanded]="openPanels.includes('common-info')">
  <mat-expansion-panel-header (click)="changePanelStatus('common-info')" class="header-holder">
    <mat-panel-description>
      <mat-icon>article</mat-icon>
    </mat-panel-description>
    <a class="title-link" id="common-info" [routerLink]="['.']" [replaceUrl]="true" [fragment]="'common-info'">
      {{ panelTitles['common-info'] }}
      <button class="link-button" (click)="copyToClipboard('common-info', $event)"><mat-icon>link</mat-icon></button>
    </a>
  </mat-expansion-panel-header>
  @if (openPanels.includes('common-info')) {
    <app-edit-common-form></app-edit-common-form>
  }
</mat-expansion-panel>

<mat-expansion-panel class="home-expansion-panel" [expanded]="openPanels.includes('user-management')">
  <mat-expansion-panel-header (click)="changePanelStatus('user-management')" class="header-holder">
    <mat-panel-description>
      <mat-icon>people</mat-icon>
    </mat-panel-description>
    <a class="title-link" id="user-management" [routerLink]="['.']" [replaceUrl]="true" [fragment]="'user-management'">
      {{ panelTitles['user-management'] }}

      <button class="link-button" (click)="copyToClipboard('user-management', $event)">
        <mat-icon>link</mat-icon>
      </button>
    </a>
  </mat-expansion-panel-header>
  @if (openPanels.includes('user-management')) {
    <app-user-management></app-user-management>
  }
</mat-expansion-panel>

<mat-expansion-panel class="home-expansion-panel" [expanded]="openPanels.includes('source-docs')">
  <mat-expansion-panel-header (click)="changePanelStatus('source-docs')">
    <mat-panel-description>
      <mat-icon>folder</mat-icon>
    </mat-panel-description>
    <a class="title-link" id="source-docs" [routerLink]="['.']" [replaceUrl]="true" [fragment]="'source-docs'">
      {{ panelTitles['source-docs'] }}
      <button class="link-button" (click)="copyToClipboard('source-docs', $event)"><mat-icon>link</mat-icon></button>
    </a>
  </mat-expansion-panel-header>
  @if (openPanels.includes('source-docs')) {
    <app-choose-source-doc></app-choose-source-doc>
  }
</mat-expansion-panel>

<mat-expansion-panel class="home-expansion-panel" [expanded]="openPanels.includes('persona-management')">
  <mat-expansion-panel-header (click)="changePanelStatus('persona-management')">
    <mat-panel-description>
      <mat-icon>smart_toy</mat-icon>
    </mat-panel-description>
    <a
      class="title-link"
      id="persona-management"
      [routerLink]="['.']"
      [replaceUrl]="true"
      [fragment]="'persona-management'">
      {{ panelTitles['persona-management'] }}
      <button class="link-button" (click)="copyToClipboard('persona-management', $event)">
        <mat-icon>link</mat-icon>
      </button>
    </a>
  </mat-expansion-panel-header>
  @if (openPanels.includes('persona-management')) {
    <app-persona-management></app-persona-management>
  }
</mat-expansion-panel>

<mat-expansion-panel class="home-expansion-panel" [expanded]="openPanels.includes('status-management')">
  <mat-expansion-panel-header (click)="changePanelStatus('status-management')">
    <mat-panel-description>
      <mat-icon>check_circle</mat-icon>
    </mat-panel-description>
    <a
      class="title-link"
      id="status-management"
      [routerLink]="['.']"
      [replaceUrl]="true"
      [fragment]="'status-management'">
      {{ panelTitles['status-management'] }}
      <button class="link-button" (click)="copyToClipboard('status-management', $event)">
        <mat-icon>link</mat-icon>
      </button>
    </a>
  </mat-expansion-panel-header>
  @if (openPanels.includes('status-management')) {
    <app-status-management></app-status-management>
  }
</mat-expansion-panel>
